import { connect } from 'react-redux';
import MemberLogin from './pure';

const mapStateToProps = (state, ownProps) => ({
  redirect_url: state.memberLogin.redirect_url,
})

const mapDispatchToProps = (dispatch) => ({
  onLoadHeaderColor: (COLOR) => dispatch({ type: 'HEADER_COLOR_' + COLOR }),
  onLoadHeaderTheme: (THEME) => dispatch({ type: 'HEADER_THEME_' + THEME }),
  onLoadShowLanguage: (STATUS) => dispatch({ type: STATUS + '_LANGUAGE' }),
  onLoadShowBreadcrumb: (STATUS, data) => dispatch({ type: STATUS + '_BREADCRUMB', breadcrumbData: data }),
  setSocialNetworkResponse: (response) => dispatch({ type: 'SET_SN_RESPONSE', response: response }),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MemberLogin);
